export const GET_APPROVERS_REQUEST = "GET_APPROVERS_REQUEST";
export const GET_APPROVERS_SUCCESS = "GET_APPROVERS_SUCCESS";
export const GET_APPROVERS_FAILURE = "GET_APPROVERS_FAILURE";
export const GET_APPROVERS_RESET = "GET_APPROVERS_RESET";
export const getApproversRequest = (payload) => ({
    type: GET_APPROVERS_REQUEST,
    payload,
});
export const getApproversSuccess = (payload) => ({
    type: GET_APPROVERS_SUCCESS,
    payload,
});
export const getApproversFailure = (payload) => ({
    type: GET_APPROVERS_FAILURE,
    payload,
});
export const getApproversReset = () => ({
    type: GET_APPROVERS_RESET,
});
